import React, { Fragment, useEffect, useState } from "react";
import { t } from 'i18next';

import {
    Row,
    Col,
	Form,
	Modal,
	Input,
	Label,
	Button,
	ModalBody,
	ModalHeader,
	FormFeedback,
} from "reactstrap";

import Select from 'react-select'
import classnames from 'classnames';

import useApi from "@hooks/useApi";
import useLoader from "@hooks/useLoader";

import { ReactSelectStyles } from "@utils"

export function TimetableModal({isOpen, handleModal, onSubmit, lessonId, setLessonId, studentId, addChoice=false}) {

    const [datas, setDatas] = useState({})

    const [lessonOption, setLessonOption] = useState([])
    const [lektsOption, setLektsOption] = useState({})
    const [semOption, setSemOption] = useState({})
    const [labOption, setLabOption] = useState({})
    const [prakOption, setPrakOption] = useState({})

    const [lektsId, setLektsId] = useState('')
    const [semId, setSemId] = useState('')
    const [labId, setLabId] = useState('')
    const [prakId, setPrakId] = useState('')


    const [teacherId, setTeacherId] = useState('')
    const { isLoading, fetchData } = useLoader({})

    const choiceApi = useApi().surgalt

    async function getDatas() {
        const {success, data} = await fetchData(choiceApi.getChoice(lessonId))
        if (success) setDatas(data)
    }

    async function getLessonDatas() {
        const {success, data} = await fetchData(choiceApi.getChoiceLesson(studentId))
        if (success) {
            if (!addChoice) {
                var one_lesson = data.filter((c) => c.id === lessonId)
                setLessonOption(one_lesson)
            } else {
                setLessonOption(data)
            }
        }
    }

    useEffect(
        () =>
        {
            if (lessonId) getDatas()
        },
        [lessonId]
    )

    useEffect(
        () =>
        {
            getLessonDatas()
        },
        []
    )

    return (
        <Fragment>
            <Modal
                isOpen={isOpen}
                toggle={handleModal}
                className="modal-dialog-centered modal-lg"
                onClosed={handleModal}
                style={{maxWidth: '1000px', width: '100%',}}
            >
                <ModalHeader className='bg-transparent' toggle={handleModal}>
                    {t('Хичээл сонголт хийх')}
                </ModalHeader>
                <ModalBody >
                    <div className="d-flex justify-content-between">
                        <div className="me-50">
                            <Label className="form-label" for="lesson">
                                {t('Хичээл')}
                            </Label>
                            <Select
                                name="leave_type"
                                id="leave_type"
                                classNamePrefix='select'
                                isClearable
                                className={classnames('react-select')}
                                isLoading={isLoading}
                                placeholder={t(`-- Сонгоно уу --`)}
                                options={lessonOption || []}
                                value={lessonOption.find((c) => c.id === lessonId)}
                                noOptionsMessage={() => t('Хоосон байна.')}
                                isDisabled={!addChoice}
                                onChange={(val) => {
                                    setLessonId(val?.id || '')
                                }}
                                styles={ReactSelectStyles}
                                getOptionValue={(option) => option.id}
                                getOptionLabel={(option) => option.name}
                            />
                            {/* {errors.request && <FormFeedback className='d-block'>{t(errors.request.message)}</FormFeedback>} */}
                        </div>
                        <div className="me-50">
                            <Label className="form-label" for="teacher">
                                {t('Багш')}
                            </Label>
                            <Select
                                name="teacher"
                                id="teacher"
                                classNamePrefix='select'
                                isClearable
                                className={classnames('react-select')}
                                isLoading={isLoading}
                                placeholder={t(`-- Сонгоно уу --`)}
                                options={datas?.teacher || []}
                                value={datas?.teacher?.find((c) => c.id === teacherId)}
                                noOptionsMessage={() => t('Хоосон байна.')}
                                onChange={(val) => {
                                    if (val?.id) {
                                        setTeacherId(val?.id || '')
                                        setLektsOption(val?.lekts)
                                        setSemOption(val?.seminar)
                                        setLabOption(val?.laborator)
                                        setPrakOption(val?.practic)
                                    } else {
                                        setLektsOption({})
                                        setSemOption({})
                                        setLabOption({})
                                        setPrakOption({})
                                    }
                                }}
                                styles={ReactSelectStyles}
                                getOptionValue={(option) => option.id}
                                getOptionLabel={(option) => option.name}
                            />
                            {/* {errors.request && <FormFeedback className='d-block'>{t(errors.request.message)}</FormFeedback>} */}
                        </div>
                        <div className="me-50">
                            <Label className="form-label" for="lekts">
                                {t('Лекц')}
                            </Label>
                            <Select
                                name="lekts"
                                id="lekts"
                                classNamePrefix='select'
                                isClearable
                                className={classnames('react-select')}
                                isLoading={isLoading}
                                isDisabled={!lektsOption?.is_timetable}
                                placeholder={t(`-- Сонгоно уу --`)}
                                options={lektsOption?.time_option || []}
                                value={lektsOption?.time_option?.find((c) => c.id === lektsId)}
                                noOptionsMessage={() => t('Хоосон байна.')}
                                onChange={(val) => {
                                    setLektsId(val?.time_id || '')
                                }}
                                styles={ReactSelectStyles}
                                getOptionValue={(option) => option.time_id}
                                getOptionLabel={(option) => option.is_full ? `${option.time_day} (дүүрсэн)` : option.time_day }
                            />
                            {/* {errors.request && <FormFeedback className='d-block'>{t(errors.request.message)}</FormFeedback>} */}
                        </div>
                        <div className="me-50">
                            <Label className="form-label" for="seminar">
                                {t('Семинар')}
                            </Label>
                            <Select
                                name="seminar"
                                id="seminar"
                                classNamePrefix='select'
                                isClearable
                                className={classnames('react-select')}
                                isLoading={isLoading}
                                isDisabled={!semOption?.is_timetable}
                                placeholder={t(`-- Сонгоно уу --`)}
                                options={semOption?.time_option || []}
                                value={semOption?.time_option?.find((c) => c.id === semId)}
                                noOptionsMessage={() => t('Хоосон байна.')}
                                onChange={(val) => {
                                    setSemId(val?.time_id || '')
                                }}
                                styles={ReactSelectStyles}
                                getOptionValue={(option) => option.time_id}
                                getOptionLabel={(option) => option.is_full ? `${option.time_day} (дүүрсэн)` : option.time_day }
                            />
                            {/* {errors.request && <FormFeedback className='d-block'>{t(errors.request.message)}</FormFeedback>} */}
                        </div>
                        <div className="me-50">
                            <Label className="form-label" for="lab">
                                {t('Лаборатор')}
                            </Label>
                            <Select
                                name="lab"
                                id="lab"
                                classNamePrefix='select'
                                isClearable
                                className={classnames('react-select')}
                                isLoading={isLoading}
                                isDisabled={!labOption?.is_timetable}
                                placeholder={t(`-- Сонгоно уу --`)}
                                options={labOption?.time_option || []}
                                value={labOption?.time_option?.find((c) => c.id === labId)}
                                noOptionsMessage={() => t('Хоосон байна.')}
                                onChange={(val) => {
                                    setLabId(val?.time_id || '')
                                }}
                                styles={ReactSelectStyles}
                                getOptionValue={(option) => option.time_id}
                                getOptionLabel={(option) => option.is_full ? `${option.time_day} (дүүрсэн)` : option.time_day }
                            />
                            {/* {errors.request && <FormFeedback className='d-block'>{t(errors.request.message)}</FormFeedback>} */}
                        </div>
                        <div className="me-50">
                            <Label className="form-label" for="praktic">
                                {t('Практик')}
                            </Label>
                            <Select
                                name="praktic"
                                id="praktic"
                                classNamePrefix='select'
                                isClearable
                                className={classnames('react-select')}
                                isLoading={isLoading}
                                isDisabled={!prakOption?.is_timetable}
                                placeholder={t(`-- Сонгоно уу --`)}
                                options={prakOption?.time_option || []}
                                value={prakOption?.time_option?.find((c) => c.id === prakId)}
                                noOptionsMessage={() => t('Хоосон байна.')}
                                onChange={(val) => {
                                    setPrakId(val?.time_id || '')
                                }}
                                styles={ReactSelectStyles}
                                getOptionValue={(option) => option.time_id}
                                getOptionLabel={(option) => option.is_full ? `${option.time_day} (дүүрсэн)` : option.time_day }
                            />
                            {/* {errors.request && <FormFeedback className='d-block'>{t(errors.request.message)}</FormFeedback>} */}
                        </div>
                    </div>
                    <Col md={12} className="text-center mt-2">
                        <Button className="me-2" color="primary" type="submit">
                            {t('Хадгалах')}
                        </Button>
                        <Button color="secondary" type="reset" outline  onClick={handleModal}>
                            {t('Буцах')}
                        </Button>
                    </Col>
                </ModalBody>
            </Modal>
        </Fragment>
    )
}